import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { clearStoreId, setStoreId, setStoreName } from "../../../store/slices/storeSlice";

const VendorStore = ({isClearable}) => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.vendorStoresOption || {});
  const { storeId } = useSelector((state) => state?.storeData || {});

  return (
    <>
      <div className="form-group m-0 row mr-5">
        <label className="col-form-label font-weight-bolder mr-4">
          Select Store
        </label>
        <div className="store_option w-235px">
          <Select
            placeholder="Select Store"
            isClearable={isClearable}
            value={data?.length > 0
              ? data
                .filter((obj) => obj.storeId === storeId)
                .map(({ storeId, storeName }) => ({
                  label: storeName?.en,
                  value: storeId,
                }))[0]
              : null
            }
            options={data?.map((store) => ({
              label: store?.storeName?.en,
              value: store?.storeId,
            }))}
            onChange={(val) => {
              if (val?.value) {
                dispatch(setStoreId(val?.value));
                dispatch(setStoreName(val?.label));
              }
              else{
                dispatch(clearStoreId());
              }
            }}
          ></Select>
        </div>
      </div>
    </>
  );
};

export default VendorStore;
